'use client'
import React from 'react'
import { useQuery } from '@apollo/client'

import MyImage from '../../myImage'
import { getImgURL } from '@/shared/utils'
import articlePlaceholder from '@/assets/images/placeholder/articlePlaceholder.svg'
import CustomLink from '../../customLink'
import { ClockIcon } from '@/shared/Icons'
import { allRoutes } from '@/shared/constants/allRoutes'
import { BLUR_DATA_URL_BASE64 } from '@/shared/constants'
import { GET_CATEGORY_NEWS_VIDEOS } from '@/graphql/article/article.query'

function LatestNews() {
  const { data } = useQuery(GET_CATEGORY_NEWS_VIDEOS, {
    variables: {
      input: {
        eType: 'n',
        nSkip: 1,
        nLimit: 10,
        iCategoryId: '650be63816a93017a893c249'
      }
    }
  })

  const newsData = data?.listSimpleCategoryArticlesVideosFront?.oArticles?.aResults

  if (newsData?.length === 0) return null

  return (
    <>
      <div className="w-full mb-4">
        <div className={`flex justify-between items-center mb-4 mt-3`}>
          <h3 className="font-bold text-lg mb-0 flex items-center text-textOffWhite justify-center md:justify-start">
            <span>Latest News</span>
          </h3>
          <CustomLink
            href={allRoutes.cricketNews as string}
            className="font-medium text-sm text-primary-500 hover:text-primary-500 transition-colors"
          >
            View All
          </CustomLink>
        </div>
        <div className="flex flex-col gap-4">
          {newsData?.slice(0, 6).map((article: any) => {
            return (
              <CustomLink
                href={article?.oSeo?.sSlug ? `/${article?.oSeo?.sSlug}` : ''}
                id={article?._id}
                key={article._id}
                className="col-span-12 flex gap-3 relative cursor-pointer w-full"
              >
                <div className="w-[30%] rounded-lg aspect-[16/10] overflow-hidden">
                  <MyImage
                    src={article?.oImg?.sUrl ? getImgURL(article?.oImg?.sUrl) : articlePlaceholder}
                    alt={article?.oImg?.sText || article?.sTitle || 'No Title'}
                    placeholder="blur"
                    placeholderImage={articlePlaceholder}
                    blurDataURL={BLUR_DATA_URL_BASE64}
                    height={84}
                    width={140}
                    className="rounded-lg object-cover h-full w-full"
                  />
                </div>
                <div className="flex flex-col justify-around text-white w-[70%]">
                  <h3 className="font-medium text-base text-textOffWhite leading-5 hover:text-primary-500 mb-1.5 line-clamp-2">
                    {article?.sTitle || 'No Title'}
                  </h3>

                  <div className="flex flex-row items-center gap-2">
                    <ClockIcon />
                    <span className="text-xs text-t-light">{article?.nDuration ?? 'N/A'} Mins</span>
                  </div>
                </div>
              </CustomLink>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default LatestNews
